export const DEFAULT_AUTH_RELATED_NOISE_DOMAINS: readonly string[] = [
  'cheqzone.com',
  'perimeterx.com',
  'px-cdn.net',
  'px-cloud.net',
  'datadome.co',
  'recaptcha.net',
  'hcaptcha.com',
  'arkoselabs.com',
  'fingerprintjs.com',
  'fpjs.io',
  'auth0.com',
  'okta.com',
  'oktacdn.com',
  'duo.com',
  'amazoncognito.com',
  'microsoftonline.com',
];

export const DEFAULT_OAST_CALLBACK_DOMAINS: readonly string[] = [
  'oast.fun',
  'oast.pro',
  'oast.live',
  'oast.site',
  'oast.online',
  'oast.me',
  'interactsh.com',
];

export const DEFAULT_OAUTH_IDENTITY_NOISE_DOMAINS: readonly string[] = [
  'facebook.com',
  'linkedin.com',
  'googleapis.com',
  'google.com',
  'google.co.il',
  'google.co.uk',
  'google.de',
  'google.fr',
  'google.es',
  'google.it',
  'google.nl',
  'google.pl',
  'google.be',
  'google.at',
  'google.ch',
  'google.co.jp',
  'google.co.in',
  'google.com.au',
  'google.ca',
  'google.com.br',
  'google.com.mx',
  'apple.com',
];

export const DEFAULT_NOISE_DOMAINS: readonly string[] = [
  'sentry.io',
  'datadoghq.com',
  'browser-intake-datadoghq.com',
  'newrelic.com',
  'bam.nr-data.net',
  'bugsnag.com',
  'rollbar.com',
  'logrocket.com',
  'logrocket.io',
  'raygun.com',
  'crashlytics.com',
  'appsignal.com',
  'honeybadger.io',
  'airbrake.io',
  'atatus.com',
  'dynatrace.com',
  'loggly.com',
  'sumologic.com',
  'siteimprove.com',

  'google-analytics.com',
  'googletagmanager.com',
  'amplitude.com',
  'mixpanel.com',
  'cdn.mxpnl.com',
  'segment.io',
  'segment.com',
  'heap.io',
  'heapanalytics.com',
  'hotjar.com',
  'fullstory.com',
  'pendo.io',
  'mouseflow.com',
  'clarity.ms',
  'plausible.io',
  'matomo.cloud',
  'posthog.com',
  '6sc.co',
  'metadata.io',
  'clearbitscripts.com',
  'clearbitjs.com',
  'clearbit.com',
  'liadm.com',
  'usbrowserspeed.com',
  'zi-scripts.com',
  'immagnify.com',
  'gostellar.app',
  'byspotify.com',
  'spotify.com',
  'rudderstack.com',
  'mparticle.com',
  'treasuredata.com',
  'crazyegg.com',
  'luckyorange.com',
  'luckyorange.net',

  'ipify.org',
  'ipinfo.io',
  'ip-api.com',
  'geojs.io',

  'smartlook.com',
  'inspectlet.com',
  'quantummetric.com',
  'contentsquare.com',
  'contentsquare.net',
  'glassboxdigital.com',
  'decibelinsight.net',

  'doubleclick.net',
  '2mdn.net',
  'googlesyndication.com',
  'googsignalservices.com',
  'adtrafficquality.google',
  'facebook.net',
  'fbcdn.net',
  'fbsbx.com',
  'snap.licdn.com',
  'criteo.com',
  'criteo.net',
  'bidswitch.net',
  'adsrvr.org',
  'adnxs.com',
  'rubiconproject.com',
  'pubmatic.com',
  'outbrain.com',
  'taboola.com',
  'moatads.com',
  'bing.com',
  'stackadapt.com',
  'ads-twitter.com',
  'twitter.com',
  't.co',
  'reddit.com',
  'redditstatic.com',
  'youtube.com',
  'tiktok.com',
  'snapchat.com',
  'openx.net',
  'casalemedia.com',
  'sharethrough.com',
  'yieldmo.com',
  'adform.net',
  '3lift.com',
  'smartadserver.com',
  'media.net',
  'sonobi.com',
  '360yield.com',
  'turn.com',
  'mfadsrvr.com',
  'simpli.fi',
  'creativecdn.com',
  'amazon-adsystem.com',

  'a-mo.net',
  'a-mx.com',
  'amx1.net',
  'bidr.io',
  'id5-sync.com',
  'intentiq.com',
  'kueezrtb.com',
  'rlcdn.com',
  'rtb.mx',
  '1rx.io',
  'crwdcntrl.net',
  'demdex.net',
  'everesttech.net',
  'mathtag.com',
  'semasio.net',
  'fwmrm.net',
  'pippio.com',
  'unrulymedia.com',
  'clientgear.com',
  'rqtrk.eu',
  'tsdtocl.com',
  'dns-finder.com',
  'clean.gg',
  'adncdn.net',
  'btloader.com',
  'primis.tech',
  'vidazoo.com',

  'partnerlinks.io',
  'impact.com',
  'impactradius.com',
  'shareasale.com',
  'awin1.com',
  'cj.com',

  'launchdarkly.com',
  'split.io',
  'optimizely.com',
  'statsig.com',
  'featuregates.org',
  'flagsmith.com',
  'vwo.com',
  'abtasty.com',
  'kameleoon.com',
  'dynamicyield.com',

  'tealiumiq.com',
  'tealium.com',
  'adobedtm.com',
  'omtrdc.net',

  'gstatic.com',
  'googleusercontent.com',
  'cdnjs.cloudflare.com',
  'cdn.jsdelivr.net',
  'unpkg.com',
  'gravatar.com',
  'typekit.net',
  'cloudinary.com',
  'cloudfront.net',
  'ytimg.com',
  'twimg.com',
  'imgix.net',
  'fastly.net',
  'fastlylb.net',
  'akamaized.net',
  'akamaihd.net',
  'bootstrapcdn.com',
  'fontawesome.com',
  'ampproject.org',
  'f-static.net',
  'esm.sh',
  'skypack.dev',

  'gvt1.com',
  'gvt2.com',
  'apple-dns.net',
  'microsoft.com',
  'msecnd.net',
  'yahoo.com',
  'opera.com',

  'instagram.com',
  'cdninstagram.com',
  'pinterest.com',
  'snapkit.com',

  'vimeo.com',
  'vimeocdn.com',
  'wistia.com',
  'wistia.net',
  'vidyard.com',
  'brightcove.com',
  'jwpcdn.com',

  'mapbox.com',
  'here.com',

  'intercom.io',
  'intercomcdn.com',
  'driftt.com',
  'drift.com',
  'tawk.to',
  'zdassets.com',
  'zendesk.com',
  'beacon-v2.helpscout.net',
  'freshdesk.com',
  'crisp.chat',
  'livechatinc.com',
  'js.hs-scripts.com',
  'js.hs-analytics.net',
  'js.hsforms.net',
  'js.hscollectedforms.net',
  'js.usemessages.com',
  'getwarmly.com',
  'navattic.com',

  'hubspot.com',
  'hsforms.com',
  'hs-banner.com',
  'hsadspixel.net',
  'hscollectedforms.net',
  'hubapi.com',
  'hubspotusercontent-na1.net',
  'hubspotusercontent-na2.net',
  'hubspotusercontent-eu1.net',
  'marketo.net',
  'marketo.com',
  'mktoresp.com',
  'pardot.com',
  'salesforceliveagent.com',
  'my.site.com',
  'demandbase.com',
  'company-target.com',
  'bombora.com',
  'chilipiper.com',
  'calendly.com',
  'cal.com',

  'shopify.com',
  'myshopify.com',
  'squarespace.com',
  'wixstatic.com',
  'parastorage.com',

  'braze.com',
  'braze.eu',
  'customer.io',
  'iterable.com',
  'sendgrid.net',
  'mailchimp.com',
  'mailchimpapp.com',

  'speedcurve.com',
  'go-mpulse.net',

  'cookielaw.org',
  'onetrust.com',
  'cookiebot.com',
  'trustarc.com',
  'evidon.com',
  'osano.com',
  'iubenda.com',
  'cookieyes.com',
  'usercentrics.eu',
  'usercentrics.com',

  'onesignal.com',
  'pushwoosh.com',

  'zoominfo.com',
  'dnb.com',

  'trustpilot.com',
  'reviews.io',

  'typeform.com',
  'jotform.com',
  'surveymonkey.com',
  'qualtrics.com',

  'atlassian.net',
  'statuspage.io',
  ...DEFAULT_OAUTH_IDENTITY_NOISE_DOMAINS,
  ...DEFAULT_AUTH_RELATED_NOISE_DOMAINS,
];

export const DEFAULT_NOISE_URL_EXTENSIONS: readonly string[] = [
  '.js',
  '.mjs',
  '.cjs',
  '.css',
  '.scss',
  '.sass',
  '.less',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.svg',
  '.ico',
  '.webp',
  '.avif',
  '.woff',
  '.woff2',
  '.ttf',
  '.eot',
  '.otf',
  '.map',
  '.bmp',
  '.tiff',
  '.tif',
  '.swf',
  '.mp3',
  '.mp4',
  '.webm',
  '.ogg',
  '.wav',
  '.flac',
  '.pdf',
  '.zip',
  '.tar',
  '.gz',
  '.br',
  '.bz2',
  '.xz',
  '.7z',
  '.rar',
  '.ts',
  '.tsx',
  '.jsx',
  '.vue',
  '.svelte',
  '.yml',
  '.yaml',
  '.toml',
  '.lock',
  '.txt',
  '.md',
  '.rst',
  '.log',
  '.csv',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.dmg',
  '.exe',
  '.msi',
  '.deb',
  '.rpm',
  '.apk',
  '.ipa',
  '.wasm',
];

export const DEFAULT_NOISE_URL_PATH_PREFIXES: readonly string[] = [
  '/_next/',
  '/__next/',
  '/.next/',
  '/_nuxt/',
  '/__nuxt/',
  '/_app/',
  '/__data/',
  '/_build/',
  '/@vite/',
  '/@id/',
  '/@fs/',
  '/_not-found',
  '/_head',
  '/_tree',
  '/_index',
  '/_error',
  '/.well-known/',
  '/webpack/',
  '/__webpack_hmr',
  '/sockjs-node/',
  '/_astro/',
  '/__remix/',
  '/~parcel/',
  '/.svelte-kit/',
  '/cdn-cgi/',
];

export const DEFAULT_NOISE_URL_PATH_SEGMENTS: readonly string[] = [
  '/static/js/',
  '/static/css/',
  '/static/media/',
  '/static/fonts/',
  '/static/chunks/',
  '/assets/js/',
  '/assets/css/',
  '/assets/fonts/',
  '/assets/images/',
  '/assets/media/',
  '/dist/',
  '/node_modules/',
  '/chunks/',
  '/wp-content/uploads/',
  '/wp-content/themes/',
  '/wp-includes/',
  '/wp-admin/',
  '/fonts/',
  '/media/cache/',
  '/export/',
];

export const DEFAULT_NOISE_URL_SUBSTRINGS: readonly string[] = [
  'telemetry',
  'beacon',
  'pixel',
  'heartbeat',
  'fbevents',
  'gtag',
  'gtm.js',
  'ga.js',
  '_ga',
  '/_/dynamitewebui/',
  '_rsc=',
];

export const BROWSER_INTERNAL_SCHEMES: readonly string[] = [
  'chrome-extension://',
  'moz-extension://',
  'safari-extension://',
  'about:',
  'chrome:',
  'edge:',
  'opera:',
  'brave:',
  'file://',
  'data:',
  'blob:',
];
